/* WaterWatch audio previews.
   Toggle buttons: the accessible name stays descriptive ("Hear the water
   alarm") and aria-pressed carries play/pause state, which is the correct
   pattern for a toggle — screen readers announce "toggle button, pressed".
   State is driven by the audio element's own events rather than the click,
   so it stays correct if playback is blocked, stalls, or ends on its own. */
(function () {
  function init() {
    var buttons = [].slice.call(document.querySelectorAll('.ww-audio__btn[data-ww-audio]'));
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      var audio = document.getElementById(btn.getAttribute('data-ww-audio'));
      if (!audio) return;

      function render(playing) {
        btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
        var play = btn.querySelector('.ww-audio__icon--play');
        var pause = btn.querySelector('.ww-audio__icon--pause');
        if (play) play.hidden = playing;
        if (pause) pause.hidden = !playing;
      }
      render(false);

      btn.addEventListener('click', function () {
        if (audio.paused) {
          buttons.forEach(function (other) {
            if (other === btn) return;
            var a = document.getElementById(other.getAttribute('data-ww-audio'));
            if (a && !a.paused) { a.pause(); a.currentTime = 0; }
          });
          var p = audio.play();
          if (p && typeof p.catch === 'function') { p.catch(function () { render(false); }); }
        } else {
          audio.pause();
        }
      });

      // Event-driven so the button never lies about what the audio is doing.
      audio.addEventListener('play',    function () { render(true); });
      audio.addEventListener('playing', function () { render(true); });
      audio.addEventListener('pause',   function () { render(false); });
      audio.addEventListener('ended',   function () { render(false); audio.currentTime = 0; });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
